import angular from 'angular';
import s from './step4Ctrl.module.css';
import { updateAllStepsComplete, getRedirectUrlPath, setLoading } from '../../actions/page';
import { sendOrderLabelEmail, updatePrimaryEmail } from '../../actions/returnConfirmation';
import { orderService, returnItemsService } from '../../services';
import { store } from '../../store';
import { ActionTypes } from '../../constants/enums';

angular.module('Step4Ctrl', []).controller('Step4Controller', [
  '$rootScope',
  '$scope',
  '$location',
  ($rootScope, $scope, $location) => {
    const {
      page: { isSimpleReturns, captureUserEmail, giftEmail, giftOrder },
      retailerSettings: { name: retailerName } = {},
    } = store.getState();
    const updateStoreState = () => {
      const {
        returnItems: { cartActions = [] } = {},
        returnConfirmation: { enableEmail } = {},
        returnSubmission: {
          returnProcessInfo: { is_qrcode_present: showQrCode, return_status: returnStatus } = {},
        },
        claims: { enabled: claimsEnabled },
      } = store.getState();
      $scope.enableEmail = enableEmail;
      $scope.showQrCode = showQrCode;
      $scope.needsReview = [
        cartActions.length > 0 && cartActions?.every((action) => action === ActionTypes.Claim),
        returnStatus === 'processing' && claimsEnabled,
      ].some(Boolean);
    };
    updateStoreState();
    const unsubscribeFromReduxUpdates = store.subscribe(updateStoreState);
    $scope.$on('$destroy', unsubscribeFromReduxUpdates);

    window.scrollTo({ top: 0 });
    const orderInfo = orderService.getOrder();
    $scope.s = s;
    store.dispatch(setLoading(false));
    $scope.retailer = retailerName;

    if (!orderInfo.order_info) {
      $location.path(store.dispatch(getRedirectUrlPath()));
    }

    $scope.exchangesEnabled = $scope.settings.exchanges_enabled;
    $rootScope.pageClass = 'step3-page';
    $scope.secondaryEmail = {};
    $scope.returnMethod = returnItemsService.getMethod(); // Required for classname, remove in next PR
    const returnOrder = returnItemsService.getReturnOrder();
    store.dispatch(updateAllStepsComplete(true));
    $scope.regex =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

    if (returnOrder.gift) {
      $scope.orderEmail = returnOrder.gift_email_address;
    } else {
      $scope.orderEmail = orderInfo.order_info.email;
    }

    if ($scope.settings.product_recommendations) {
      $scope.hideStep3Summary = $scope.settings.product_recommendations.hideStep3Summary;
    }

    $scope.sum = (items, prop) => items.reduce((a, b) => a + b[prop], 0);

    if ($scope.enableEmail) {
      const attachEmailAddress = giftOrder || isSimpleReturns;
      const primaryEmailAddress = giftOrder || captureUserEmail ? giftEmail : orderInfo.order_info.email;
      store.dispatch(updatePrimaryEmail(primaryEmailAddress));
      if (!$scope.needsReview) {
        store.dispatch(sendOrderLabelEmail(attachEmailAddress ? primaryEmailAddress : undefined));
      }
    }
  },
]);
